const LOCAL_STORAGE = {
  DATA_COLLECTION_STATUS: 'DATA_COLLECTION_STATUS',
};

export default LOCAL_STORAGE;
